import { render, staticRenderFns } from "./ExpressProblemTableSection.vue?vue&type=template&id=db671140&scoped=true"
import script from "./ExpressProblemTableSection.vue?vue&type=script&lang=js"
export * from "./ExpressProblemTableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db671140",
  null
  
)

export default component.exports